import React from "react";
import "./styles.scss";

const FooterThemeTwo = props => {
  return (
    <footer className="footer text-center">
      <p>Powered by Shobbu.com</p>
    </footer>
  );
};

export default FooterThemeTwo;
